import PropTypes from 'prop-types';
import { CurrencyInput, SelectInput } from './';
import { FlexContainer } from '../containers';
import { periodOptions } from '../config';

const Income = props => {
  const {
    name,
    id,
    errors,
    readOnly,
    autoFocus,
    period,
    periodOptions,
    amount,
    onAmountChangeHandler,
    onPeriodChangeHandler,
  } = props;

  return (
    <FlexContainer>
      <CurrencyInput
        autoFocus={autoFocus}
        readOnly={readOnly}
        placeholder="Bedrag"
        name={name}
        id={id}
        onChange={onAmountChangeHandler}
        value={amount}
        errors={errors}
      />
      <SelectInput
        options={periodOptions}
        onChange={onPeriodChangeHandler}
        value={period}
        placeholder="Per"
        isSearchable={false}
      />
    </FlexContainer>
  )
}

Income.propTypes = {
  autoFocus: PropTypes.bool,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  onPeriodChangeHandler: PropTypes.func,
  onAmountChangeHandler: PropTypes.func,
  amount: PropTypes.number,
  period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  periodOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

Income.defaultProps = {
  autoFocus: false,
  name: null,
  readOnly: false,
  amount: null,
  period: 'yearly',
  periodOptions,
  id: null,
  onPeriodChangeHandler: () => {},
  onAmountChangeHandler: () => {},
  errors: null,
};

export default Income;
